import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

const STORAGE_KEY = "minzo_last_seen_projects_count";

export function useNewProjectsBadge() {
  const [hasNew, setHasNew] = useState(false);

  const check = useCallback(async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) { setHasNew(false); return; }

    const { count } = await supabase
      .from("projects")
      .select("*", { count: "exact", head: true })
      .eq("user_id", session.user.id);

    const lastSeen = parseInt(localStorage.getItem(STORAGE_KEY) || "0", 10);
    setHasNew((count ?? 0) > lastSeen);
  }, []);

  const markSeen = useCallback(async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return;

    const { count } = await supabase
      .from("projects")
      .select("*", { count: "exact", head: true })
      .eq("user_id", session.user.id);

    localStorage.setItem(STORAGE_KEY, String(count ?? 0));
    setHasNew(false);
  }, []);

  useEffect(() => { check(); }, [check]);

  return { hasNew, markSeen, recheck: check };
}
